import React from "react";
import withLocalization from "../../../hoc/with-localization";
const PrmTableHR = props => {
    let { HR, stimulator, stimulatorType, loc } = props;

    const stim_unknowntype = !/\S/.test(stimulatorType); // regexp - есть ли хоть 1 не пробел
    if (stim_unknowntype) {
        stimulatorType = loc("report.labels.pacemaker_unknown");
    }
    return (
        <table className="prm-table prm-table-HR">
            <tbody>
                <tr>
                    <td className="prm-title">{loc("report.params.HR")}</td>
                    <td className="prm-data">{HR.val}</td>
                    <td className="prm-units">{loc("units.bpm")}</td>
                    <td className="prm-gap"></td>
                    {stimulator && (
                        <>
                            <td className="prm-title prm-title-pacemaker">{loc("report.labels.pacemaker")}</td>
                            <td className="prm-data prm-data-pacemaker">{stimulatorType}</td>
                        </>
                    )}
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(PrmTableHR);
